import Display from './display'

Display.install = vue => vue.component(Display.name, Display)

export default Display
